export default {"src":"/_next/static/media/Home.3239790b.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};